import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { AccessibleDropListDirective } from '@go-modules/directives/accessible-drop-list/accessible-drop-list.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ManageCollectionsPanelComponent } from './manage-collections-panel.component';
import { ModifyCollectionsPanelModule } from '@go-modules/components/library/modify-collections-panel/modify-collections-panel.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		FocusOnFirstInvalidFieldModule,
		DragDropModule,
		AccessibleDropListDirective,
		ModifyCollectionsPanelModule
	],
	declarations: [
		ManageCollectionsPanelComponent
	],
	exports: [
		ManageCollectionsPanelComponent
	]
})
export class ManageCollectionsPanelModule {}
